import { render } from "./ResolveDefect.vue?vue&type=template&id=453f0c12"
import script from "./ResolveDefect.vue?vue&type=script&lang=js"
export * from "./ResolveDefect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__